export enum DutyTypes {
  GET_DUTY_REQUESTERS = '@duty/GET_DUTY_REQUESTERS',
  GET_DUTY_REQUESTERS_SUCCESS = '@duty/GET_DUTY_REQUESTERS_SUCCESS',
  GET_DUTY_REQUESTERS_FAILED = '@duty/GET_DUTY_REQUESTERS_FAILED',
  GET_PROFESSIONAL_ON_DUTY = '@duty/GET_PROFESSIONAL_ON_DUTY',
  GET_PROFESSIONAL_ON_DUTY_SUCCESS = '@duty/GET_PROFESSIONAL_ON_DUTY_SUCCESS',
  GET_PROFESSIONAL_ON_DUTY_FAILED = '@duty/GET_PROFESSIONAL_ON_DUTY_FAILED',
}
